import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IInvoiceGeneratorMenu {
  isMenuOpen: boolean;
}

const initialState: IInvoiceGeneratorMenu = {
  isMenuOpen: true,
};

const invoiceGeneratorMenuSlice = createSlice({
  name: 'invoiceGeneratorMenuSlice',
  initialState,
  reducers: {
    setIsGeneratorMenuOpen(state, { payload }: PayloadAction<boolean>) {
      state.isMenuOpen = payload;
    },
  },
});

export const invoiceGeneratorMenuReducer = invoiceGeneratorMenuSlice.reducer;
export const { setIsGeneratorMenuOpen } = invoiceGeneratorMenuSlice.actions;
